import { render, staticRenderFns } from "./BalikanSerahTerima.vue?vue&type=template&id=516550c0&scoped=true&"
import script from "./BalikanSerahTerima.vue?vue&type=script&lang=ts&"
export * from "./BalikanSerahTerima.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516550c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('516550c0')) {
      api.createRecord('516550c0', component.options)
    } else {
      api.reload('516550c0', component.options)
    }
    module.hot.accept("./BalikanSerahTerima.vue?vue&type=template&id=516550c0&scoped=true&", function () {
      api.rerender('516550c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/berita-acara/ba-serah-terima/BalikanSerahTerima.vue"
export default component.exports